<script lang="ts">
    import { lg } from 'hydria/services/language'

    interface Props {
        phone: string | null | undefined
        empty?: string | null | undefined
    }

    let { phone, empty = '–' }: Props = $props()

    let visual: string | undefined = $derived.by(() => {
        if (phone == null || phone == '') return empty != null ? empty : undefined

        if (phone.startsWith('+1.')) {
            const [base, ext] = phone.slice(3).split('x')
            if (base.length != 10) return phone

            let loc = ''
            if ($lg == 'fr') loc = `${base.slice(0, 3)} ${base.slice(3, 6)}-${base.slice(6)}`
            else loc = `${base.slice(0, 3)}-${base.slice(3, 6)}-${base.slice(6)}`

            if (ext) loc += `${$lg == 'fr' ? ', poste' : ' ext.'} ${ext}`

            return loc
        }

        return empty != null ? empty : undefined
    })
</script>

{#if visual}{visual}{/if}
